export interface IdleDeadline {
  /**
   * A Boolean whose value is true if the callback is being executed because the timeout specified when the idle callback was installed has expired.
   */
  didTimeout: boolean;
  /**
   * Returns a DOMHighResTimeStamp, which is a floating-point value providing an estimate of the number of milliseconds remaining in the current idle period.
   * If the idle period is over, the value is 0. Your callback can call this repeatedly to see if there's enough time left to do more work before returning.
   * @returns {DOMHighResTimeStamp}
   */
  timeRemaining: () => number;
}

export interface RequestIdleCallbackOptions {
  timeout?: number;
}
export interface BackgroundTasksAPI {
  requestIdleCallback: (callback: (idleDeadline: IdleDeadline) => void, options?: RequestIdleCallbackOptions) => number;
  cancelIdleCallback: (handle: number) => void;
};

const w = window as Window & typeof globalThis & Partial<BackgroundTasksAPI>;

export const BackgroundTasksAPI = {
  requestIdleCallback: w.requestIdleCallback?.bind(w) || (
    // Polyfill copied frpm MDN
    // https://developer.mozilla.org/en-US/docs/Web/API/Background_Tasks_API#falling_back_to_settimeout
    (handler): number => {
      const startTime = Date.now();

      return window.setTimeout(() => {
        handler({
          didTimeout: false,
          timeRemaining: () => Math.max(0, 50.0 - (Date.now() - startTime)),
        });
      }, 1);
    }
  ),

  cancelIdleCallback: w.cancelIdleCallback?.bind(w) || (
    (id): void => window.clearTimeout(id)
  ),
};
